import React, { Component } from "react";
import AntdSteps, {StepsProps} from "antd/lib/steps";
import "antd/lib/steps/style";

const { Step } = AntdSteps;
export default class Steps extends Component<StepsProps> {
  static Step = Step;
  render() {
    return <AntdSteps {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/steps/index.tsx